import { OutletListItem } from '@ancon/wildcat-types'
import isOutletAcceptingPreOrdersWhenClosed from '@ancon/wildcat-utils/outlet/isOutletAcceptingPreOrdersWhenClosed'

import isOutletAcceptingOnlyPreOrdersWhenOpen from './isOutletAcceptingOnlyPreOrdersWhenOpen'

/**
 * Checks if the outlet is in pre-order mode. The ASAP ordering will be disabled in pre-order mode.
 * An outlet is considered to be in pre-order mode if it is either:
 * 1. Accepting pre-orders when closed.
 * 2. Accepting only pre-orders when open.
 */
export default function isOutletInPreOrderOnlyMode(
  outlet: OutletListItem | null,
) {
  const isAcceptingPreOrdersWhenClosed =
    isOutletAcceptingPreOrdersWhenClosed(outlet)

  const isAcceptingOnlyPreOrdersWhenOpen =
    isOutletAcceptingOnlyPreOrdersWhenOpen(outlet)

  return isAcceptingPreOrdersWhenClosed || isAcceptingOnlyPreOrdersWhenOpen
}
